import * as React from "react";
import { cn } from "../../lib/utils"; // Relative path to utils

/**
 * Props for the AwardCard component.
 */
export interface AwardCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The icon to be displayed. Can be an SVG, <img>, or any ReactNode.
   */
  icon: React.ReactNode;
  /**
   * The small heading or category (e.g., "1st Place").
   */
  title: string;
  /**
   * The main description or name of the awarding entity.
   */
  description: string;
}

const AwardCard = React.forwardRef<HTMLDivElement, AwardCardProps>(
  ({ className, icon, title, description, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center gap-2 sm:gap-3",
          className
        )}
        {...props}
      >
        {/* Icon Slot */}
        <div className="flex-shrink-0 text-foreground flex items-center justify-center">{icon}</div>

        {/* Text Content */}
        <div className="flex flex-col items-center text-center min-w-0">
          <p className="text-xs sm:text-sm text-muted-foreground">{title}</p>
          <p className="text-xs sm:text-base font-medium text-foreground">{description}</p>
        </div>
      </div>
    );
  }
);
AwardCard.displayName = "AwardCard";

export { AwardCard };

